module.exports = __webpack_public_path__ + "static/media/25012.ee0b3213.jpg";